'use strict';

var $ = require('jquery');
var Cookies = require('../../components/cookie');
var util = require('../../utils/util');
exports.init = function () {
    var $container = $('.multiple-variations-info, .message.default-form');

    $container.on('click keypress', '.close', function (e) {
        if (util.isClickOrSpaceOrEnter(e)) {
            $container.fadeOut();
            Cookies.set('HideMultipleVariations', true);
        }
    });
};
